import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class CavvPreauthSample extends Component {
    getOrderId() {
        const { order_id, selectedProgLangId } = this.props;
        if(order_id === "none") {
            switch(selectedProgLangId) {
                case _DOTNET:
                    return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
                case _JAVA:
                    return `"Test"+createDate.getTime()`;
                case _PHP:
                    return `'ord-'.date("dmy-G:i:s")`;
                default:
                    return "";
            }
        }
        else
            return `"${order_id}"`;
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    render() {
        const { storeId, apiToken, pan, expdate, amount, cavv, eci, selectedProgLangId } = this.props;

        switch(selectedProgLangId) {
            case _DOTNET:
                return (
                    <pre className="sampleCode">
{`namespace Moneris
{
 using System;
 using System.Collections;
 public class TestCanadaCavvPreauth
 {
  public static void Main(string[] args)
  {
   string store_id = "`}{this.getValue(storeId, "storeId")}{`";
   string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
   string order_id = ${this.getOrderId()};
   string cust_id = "CUS887H67";
   string amount = "`}{this.getValue(amount, "amount")}{`";
   string pan = "`}{this.getValue(pan, "pan")}{`";
   string expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
   string cavv = "${cavv}";
   string dynamic_descriptor = "123456";
   string wallet_indicator = "APP";
   string processing_country_code = "CA";
   string crypt_type = "${eci}";
   bool status_check = false;
   
   CofInfo cof = new CofInfo();
   
   cof.SetPaymentIndicator("U");
   cof.SetPaymentInformation("2");
   cof.SetIssuerId("168451306048014");
   
   CavvPreAuth cavvPreauth = new CavvPreAuth();
   
   cavvPreauth.SetOrderId(order_id);
   cavvPreauth.SetCustId(cust_id);
   cavvPreauth.SetAmount(amount);
   cavvPreauth.SetPan(pan);
   cavvPreauth.SetExpDate(expdate);
   cavvPreauth.SetCavv(cavv);
   cavvPreauth.SetCryptType(crypt_type); //Mandatory for AMEX cards only
   cavvPreauth.SetDynamicDescriptor(dynamic_descriptor);
   cavvPreauth.SetThreeDSVersion("2"); //Mandatory for 3DS Version 2.0+
   cavvPreauth.SetThreeDSServerTransId("e11d4985-8d25-40ed-99d6-c3803fe5e68f"); //Mandatory for 3DS
   
   Version 2.0+ - obtained from MpiCavvLookup or MpiThreeDSAuthentication
   //cavvPreauth.SetWalletIndicator(wallet_indicator); //set only wallet transactions e.g. APPLE PAY
   //cavvPreauth.SetCmId("8nAK8712sGaAkls56"); //set only for usage with Offlinx - Unique max 50
   alphanumeric characters transaction id generated by merchant
   cavvPreauth.SetCofInfo(cof);
   
   cavvPreauth.SetDsTransId("12345"); //Optional - to be used only if you are using 3rd party 3DS 2.2 service

   HttpsPostRequest mpgReq = new HttpsPostRequest();
   mpgReq.SetProcCountryCode(processing_country_code);
   mpgReq.SetTestMode(true); //false or comment out this line for production transactions
   mpgReq.SetStoreId(store_id);
   mpgReq.SetApiToken(api_token);
   mpgReq.SetTransaction(cavvPreauth);
   mpgReq.SetStatusCheck(status_check);
   mpgReq.Send();

   try
   { 
    Receipt receipt = mpgReq.GetReceipt();
    Console.WriteLine("CardType = " + receipt.GetCardType());
    Console.WriteLine("TransAmount = " + receipt.GetTransAmount());
    Console.WriteLine("TxnNumber = " + receipt.GetTxnNumber());
    Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
    Console.WriteLine("TransType = " + receipt.GetTransType());
    Console.WriteLine("ReferenceNum = " + receipt.GetReferenceNum());
    Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
    Console.WriteLine("ISO = " + receipt.GetISO());
    Console.WriteLine("BankTotals = " + receipt.GetBankTotals());
    Console.WriteLine("Message = " + receipt.GetMessage());
    Console.WriteLine("AuthCode = " + receipt.GetAuthCode());
    Console.WriteLine("Complete = " + receipt.GetComplete());
    Console.WriteLine("TransDate = " + receipt.GetTransDate());
    Console.WriteLine("TransTime = " + receipt.GetTransTime());
    Console.WriteLine("Ticket = " + receipt.GetTicket());
    Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
    Console.WriteLine("CavvResultCode = " + receipt.GetCavvResultCode());
    Console.WriteLine("IssuerId = " + receipt.GetIssuerId());
    Console.WriteLine("ThreeDSVersion = " + receipt.GetThreeDSVersion());
    Console.ReadLine();
   } 
    catch (Exception e)
   { 
    Console.WriteLine(e);
   }
  }
 }
}
`}
                </pre>)

        case _JAVA:
            return (
                <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaCavvPreauth
{ 
 public static void main(String[] args)
 { 
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  java.util.Date createDate = new java.util.Date();
  String order_id = ${this.getOrderId()};
  String cust_id = "CUS887H67";
  String amount = "`}{this.getValue(amount, "amount")}{`";
  String pan = "`}{this.getValue(pan, "pan")}{`";
  String expdate = "`}{this.getValue(expdate, "expdate")}{`"; //YYMM format
  String cavv = "${cavv}";
  String dynamic_descriptor = "123456";
  String processing_country_code = "CA";
  String crypt_type = "${eci}";
  boolean status_check = false;
  
  CavvPreAuth cavvPreauth = new CavvPreAuth();
  
  cavvPreauth.setOrderId(order_id);
  cavvPreauth.setCustId(cust_id);
  cavvPreauth.setAmount(amount);
  cavvPreauth.setPan(pan);
  cavvPreauth.setExpdate(expdate);
  cavvPreauth.setCavv(cavv);
  cavvPreauth.setCryptType(crypt_type); //Mandatory for AMEX only
  cavvPreauth.setDynamicDescriptor(dynamic_descriptor);
  //cavvPreauth.setWalletIndicator("APP"); //set only for wallet transactions. e.g APPLE PAY
  //cavvPreauth.setCmId("8nAK8712sGaAkls56"); //set only for usage with Offlinx - Unique max 50
  alphanumeric characters transaction id generated by merchant
  cavvPreauth.setThreeDSVersion("2"); //Mandatory for 3DS Version 2.0+
  cavvPreauth.setThreeDSServerTransId("e11d4985-8d25-40ed-99d6-c3803fe5e68f"); //Mandatory for 3DS
  Version 2.0+ - obtained from MpiCavvLookup or MpiThreeDSAuthentication
  
  cavvPreauth.setDsTransId("12345"); //Optional - to be used only if you are using 3rd party 3DS 2.2 service

  //optional - Credential on File details
  CofInfo cof = new CofInfo();
  
  cof.setPaymentIndicator("U");
  cof.setPaymentInformation("2");
  cof.setIssuerId("139X3130ASCXAS9");
  
  cavvPreauth.setCofInfo(cof);
  
  HttpsPostRequest mpgReq = new HttpsPostRequest();
  mpgReq.setProcCountryCode(processing_country_code);
  mpgReq.setTestMode(true); //false or comment out this line for production transactions
  mpgReq.setStoreId(store_id);
  mpgReq.setApiToken(api_token);
  mpgReq.setTransaction(cavvPreauth);
  mpgReq.setStatusCheck(status_check);
  mpgReq.send();
  
  try
  { 
   Receipt receipt = mpgReq.getReceipt();
   System.out.println("CardType = " + receipt.getCardType());
   System.out.println("TransAmount = " + receipt.getTransAmount());
   System.out.println("TxnNumber = " + receipt.getTxnNumber());
   System.out.println("ReceiptId = " + receipt.getReceiptId());
   System.out.println("TransType = " + receipt.getTransType());
   System.out.println("ReferenceNum = " + receipt.getReferenceNum());
   System.out.println("ResponseCode = " + receipt.getResponseCode());
   System.out.println("ISO = " + receipt.getISO());
   System.out.println("BankTotals = " + receipt.getBankTotals());
   System.out.println("Message = " + receipt.getMessage());
   System.out.println("AuthCode = " + receipt.getAuthCode());
   System.out.println("Complete = " + receipt.getComplete());
   System.out.println("TransDate = " + receipt.getTransDate());
   System.out.println("TransTime = " + receipt.getTransTime());
   System.out.println("Ticket = " + receipt.getTicket());
   System.out.println("TimedOut = " + receipt.getTimedOut());
   System.out.println("CavvResultCode = " + receipt.getCavvResultCode());
   System.out.println("IssuerId = " + receipt.getIssuerId());
   System.out.println("ThreeDSVersion = " + receipt.getThreeDSVersion());
  } 
  catch (Exception e)
  { 
   e.printStackTrace();
  }
 }
}
`}
                </pre>
            )

        case _PHP:
            return (
                <pre className="sampleCode">
{`<?php

## Example php -q TestPurchase-VBV.php "moneris" store
require "../../mpgClasses.php";

/****************** Request Variables ***********************/
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';

/**************** Transactional Variables *******************/
$type='cavv_preauth';
$order_id=${this.getOrderId()};
$cust_id='CUST887763';
$amount='`}{this.getValue(amount, "amount")}{`';
$pan="`}{this.getValue(pan, "pan")}{`";
$expiry_date="`}{this.getValue(expdate, "expdate")}{`";
$cavv='${cavv}';
$crypt_type = '${eci}';
$wallet_indicator = "APP";
$dynamic_descriptor='123456';

/************* Transaction Associative Array ****************/
$txnArray=array(
'type'=>$type,
'order_id'=>$order_id,
'cust_id'=>$cust_id,
'amount'=>$amount,
'pan'=>$pan,
'expdate'=>$expiry_date,
'cavv'=>$cavv,
'crypt_type'=>$crypt_type, //mandatory for AMEX only
//'wallet_indicator'=>$wallet_indicator, //set only for wallet transactions. e.g. APPLE PAY
'dynamic_descriptor'=>$dynamic_descriptor,
'threeds_version' => '2', //Mandatory for 3DS Version 2.0+
'threeds_server_trans_id' => 'e11d4985-8d25-40ed-99d6-c3803fe5e68f' //Mandatory for 3DS Version
2.0+ - obtained from MpiCavvLookup or MpiThreeDSAuthentication
//,'cm_id' => '8nAK8712sGaAkls56' //set only for usage with Offlinx - Unique max 50 alphanumeric
characters transaction id generated by merchant

'ds_trans_id' => '12345' //Optional - to be used only if you are using 3rd party 3DS 2.2 service
);

/****************** Transaction Object *********************/
$mpgTxn = new mpgTransaction($txnArray);

/****************** Credential on File *********************/
$cof = new CofInfo();
$cof->setPaymentIndicator("U");
$cof->setPaymentInformation("2");
$cof->setIssuerId("168451306048014");
$mpgTxn->setCofInfo($cof);

/******************** Request Object ***********************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions

/******************* HTTPS Post Object *********************/
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest);

/*********************** Response **************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nCardType = " . $mpgResponse->getCardType());
print("\\nTransAmount = " . $mpgResponse->getTransAmount());
print("\\nTxnNumber = " . $mpgResponse->getTxnNumber());
print("\\nReceiptId = " . $mpgResponse->getReceiptId());
print("\\nTransType = " . $mpgResponse->getTransType());
print("\\nReferenceNum = " . $mpgResponse->getReferenceNum());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nISO = " . $mpgResponse->getISO());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nAuthCode = " . $mpgResponse->getAuthCode());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nTicket = " . $mpgResponse->getTicket());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nCavvResultCode = " . $mpgResponse->getCavvResultCode());
print("\\nIssuerId = " . $mpgResponse->getIssuerId());
print("\\nThreeDSVersion = " . $mpgResponse->getThreeDSVersion());
?>
`}
                </pre>
            )
        default:
            return null
        }
    }
}

const mapStateToProps = state => {
  const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, onEditId } = state.threeDSTwo.main.config;
  const { selection } = state.common.progLangList;
  return { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, selectedProgLangId: selection, onEditId };
}

export default connect(mapStateToProps, {})(CavvPreauthSample)
